import {ServiceBase} from "../ServiceBase";
import {ITooltipsProvider} from "./tooltips-provider.interface";
import {IOverlayConsumer} from "../overlay/overlay-consumer.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {makeObservable, observable} from "mobx";
import {ITooltipModel} from "./tooltip-base/tooltip-model.interface";

export abstract class TooltipBaseService extends ServiceBase implements ITooltipsProvider, IOverlayConsumer {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        makeObservable(this);
        services.overlay.registerConsumer(this);
    }

    @observable
    protected _toolTips: ITooltipModel[] = [];
    get toolTips(): ITooltipModel[] {
        return this._toolTips;
    }

    onOverlayClicked() {
        //nothing to do here
    }

    getOverlayZIndex(): number | undefined {
        const toolTips = this._toolTips.filter(t => {
            //we use separate variables to make sure that this method depends on all the observable involved in the condition
            const showOverlay = t.showOverlay;
            const shouldDisplay = t.shouldDisplay();
            return showOverlay && shouldDisplay;
        });

        if(toolTips.length === 0) {
            return undefined;
        }

        return Math.max(...toolTips.map(t => t.zIndex)) - 1;
    }

    get needsOverlay(): boolean {
        const toolTips = this._toolTips.filter(t => {
            //we use separate variables to make sure that this method depends on all the observable involved in the condition
            const showOverlay = t.showOverlay;
            const shouldDisplay = t.shouldDisplay();
            return showOverlay && shouldDisplay;
        });
        return toolTips.length > 0;
    }

}